// extracted by mini-css-extract-plugin
export var ctaButton = "SectionCta-module--ctaButton--76479";
export var imgContainer = "SectionCta-module--imgContainer--53161";
export var sectionCta = "SectionCta-module--sectionCta--05f11";
export var subtitle = "SectionCta-module--subtitle--10b64";
export var title = "SectionCta-module--title--d1eef";
export var titles = "SectionCta-module--titles--05846";
export var walletImg = "SectionCta-module--walletImg--1d67b";
export var walletImgMobile = "SectionCta-module--walletImgMobile--b6c4e";